import React from "react";
import PropTypes from "prop-types";

export const MarkerBubble = ({visibility, children}) => (<div style={visibility} className="marker-bubble">{children}</div>);
export const PointName = ({children}) => (<h3 className="point-name">{children}</h3>);
export const PointDescription = ({children}) => (<p className="point-description">{children}</p>);
export const PointList = ({children}) => (<ul className="point-list">{children}</ul>);
export const PointGroupHeading = ({children}) => (<h4 className="point-group-heading">{children}</h4>);
MarkerBubble.propTypes = () => ({visibility: PropTypes.object, children: PropTypes.element.isRequired});
PointName.propTypes = () => ({children: PropTypes.element.isRequired});
PointDescription.propTypes = () => ({children: PropTypes.element.isRequired});
PointList.propTypes = () => ({children: PropTypes.element.isRequired});
PointGroupHeading.propTypes = () => ({children: PropTypes.element.isRequired});